import { createSlice } from "@reduxjs/toolkit";

const stgeesSlice = createSlice({
  name: "stgees",
  initialState: {
    stgeesArray:[]
  },
  reducers: {
    getStgees: (state, action) => {
  state.stgeesArray =action.payload;
 },
 },
});

export const { getStgees } = stgeesSlice.actions;
export default stgeesSlice.reducer;